export const MODAL_TITLE = "Submit Your Final Essay";
export const SAVE_BTN_TEXT = "Save";
export const CANCEL_BTN_TEXT = "Cancel";

export const API_ENDPOINTS = {
  get: "user/essay",
  upsert: "user/essay/upsert",
};

export const ERROR_MESSAGES = {
  fillAll: "Please fill all the fields",
};

export const LABELS = {
  title: "Title",
  essay: "Final Essay",
};

export const PLACEHOLDERS = {
  title: "Enter title",
  essay: "Write your essay...",
};
